import { getLanguageText } from '@omnia/ui/src/lib/lumos-plus/domain/selectors/get-language-text'
import type { MissingContentErrorConfiguration } from '@omnia/ui/src/lib/lumos-plus/types/missing-content-error'
import {
    ContentSection,
    ContentType,
    MissingContentError,
} from '@omnia/ui/src/lib/lumos-plus/types/missing-content-error'
import type { BrowsingLanguageTextGroup, SalesChannel } from '@vista-digital/lumos-cms-client'
import { mapLanguageText } from '@vista-digital/lumos-domain'
/**
 * Gets the browsing language text from the domain store.
 *
 * @param missingContentErrorConfig The configuration for missing content error. If no need for throwing error when language text isn't present don't pass the missingContentErrorConfig object.
 * @returns Browsing language text.
 */
export function getBrowsingLanguageText(
    missingContentErrorConfig: MissingContentErrorConfiguration
): BrowsingLanguageTextGroup<SalesChannel.Web>
export function getBrowsingLanguageText(): BrowsingLanguageTextGroup<SalesChannel.Web> | undefined
export function getBrowsingLanguageText(
    missingContentErrorConfig?: MissingContentErrorConfiguration
): BrowsingLanguageTextGroup<SalesChannel.Web> | undefined {
    const browsingLanguageText = getLanguageText()?.browsing
    if (!browsingLanguageText && missingContentErrorConfig) {
        throw new MissingContentError(
            missingContentErrorConfig.contentName,
            ContentSection.Browsing,
            ContentType.LanguageText
        )
    }
    return mapLanguageText(browsingLanguageText)
}
